<template>
    <label v-if="!labelUnder" class="c-form_label" :for="id" :class="{'-required': required}">
        {{ labelText }}
    </label>
    <input 
        class="c-form_input" 
        type="text" 
        :id="id" 
        :name="name" 
        :placeholder="placeholder" 
        :required="required" 
        :autocomplete="autocomplete" 
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    >
    <div class="c-form_validation">
        <div class="c-form_validation_required">
            {{ _t("Enter a value for this field") }}
        </div>
        <div class="c-form_validation_invalid">
            {{ _t("This field is invalid") }}
        </div>
    </div>
    <label v-if="labelUnder" :for="id" class="c-form_label_small">
        {{ labelText }}
    </label>
</template>
<script>

export default {
    name: 'Text',
    props: {
        id: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        labelText: {
            type: String,
            default: ''
        },
        labelUnder: {
            type: Boolean,
            default: false
        },
        modelValue: {
            type: String,
            default: ''
        }
    },
    data() {
        return {

        };
    },
    methods: {

    },
    mounted() {

    }
};
</script>
